import React, { Component } from "react";
import CognitoIdentityServiceProvider from "aws-sdk/clients/cognitoidentityserviceprovider";
import { Auth, API, graphqlOperation, Storage } from "aws-amplify";
import { createCustomer, createInspector } from "../graphql/mutations";
import Validate from "./FormValidation";
import { toast, ToastContainer } from "react-toastify";
import { spinnerService } from "@chevtek/react-spinners";
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Container,
  Row,
  Col
} from "reactstrap";
import { connect } from "react-redux";
import * as actionTypes from "../redux/actions";
const _ = require("lodash");
// import Context from '../data/context';
Storage.configure({
  AWSS3: {
    bucket: "calbitwebappuploadbucket1254-dev", //Your bucket name;
    region: "us-east-2" //Specify the region your bucket was created in;
  }
});
let qualificationsArray = [];
let today = new Date();
let month =
  today.getMonth() + 1 < 10 ? `0${today.getMonth() + 1}` : today.getMonth() + 1;
let date = today.getDate() < 10 ? `0${today.getDate()}` : today.getDate();

let currentDate = `${today.getFullYear()}-${month}-${date}`;
class ConfirmSignUp2 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      code: "",
      password: "",
      errors: {
        cognito: null,
        blankfield: false
      }
    };
  }
  // static contextType = Context;

  clearErrorState = () => {
    this.setState({
      errors: {
        cognito: null,
        blankfield: false
      }
    });
  };

  handleSubmit = async event => {
    event.preventDefault();
    let {
      email,
      password,
      iamInspector,
      iamMechanic,
      phoneNum,
      username,
      city,
      address,
      st,
      name,
      date,
      qualifications,
      experiences,
      skills
    } = JSON.parse(await localStorage.getItem("inspectorInfo"));
    this.clearErrorState();
    iamMechanic = false;
    try {
      spinnerService.show("mySpinner");
      const confirmedUser = await Auth.confirmSignUp(
        username,
        this.state.code,
        {
          // Optional. Force user confirmation irrespective of existing alias. By default set to True.
          forceAliasCreation: true
        }
      )
        .then(data => {
          const loggedinuser = Auth.signIn(username, password).then(user2 => {
            Promise.resolve(Auth.currentAuthenticatedUser()).then(user =>
              Auth.currentCredentials()
                .then(credentials =>
                  Promise.resolve(
                    new CognitoIdentityServiceProvider({
                      apiVersion: "2016-04-18",
                      credentials: Auth.essentialCredentials(credentials),
                      region: "us-east-2"
                    })
                  )
                )
                .then(client => {
                  if (iamInspector) {
                    client
                      .adminAddUserToGroup({
                        GroupName: "Inspectors",
                        UserPoolId: user.pool.userPoolId,
                        Username: user.username
                      })
                      .promise();
                  }
                  if (iamMechanic) {
                    client
                      .adminAddUserToGroup({
                        GroupName: "Mechanics",
                        UserPoolId: user.pool.userPoolId,
                        Username: user.username
                      })
                      .promise();
                  }
                })
                .then(async () => {
                  qualificationsArray = [];

                  await this.uploadImages();
                  try {
                    var input = {
                      id: username,
                      name: name,
                      email: email,
                      registrationDate: currentDate
                    };
                    //Please check here phone no format
                    if (!_.isEmpty(phoneNum) && _.isString(phoneNum)) {
                      input.phoneNo = phoneNum;
                    }
                    //else { input.phoneNo = null;  }
                    if (!_.isEmpty(city) && _.isString(city)) {
                      input.city = city;
                    }
                    //else { input.city = null; }
                    if (!_.isEmpty(address) && _.isString(address)) {
                      input.homeAddress = address;
                    }
                    //else { input.homeAddress = null; }
                    if (!_.isEmpty(st) && _.isString(st)) {
                      input.state = st;
                    }
                    //else {input.state = null;}
                    if (date !== "") {
                      input.inspectingSince = date;
                    }
                    if (qualifications.length !== 0) {
                      input.qualifications = qualificationsArray;
                    }
                    if (experiences.length !== 0) {
                      input.employmentHistory = experiences;
                    }
                    if (skills.length !== 0) {
                      input.skills = skills;
                    }

                    // let inspType = [];
                    // if (iamInspector) inspType.push("INSPECTOR");
                    // if (iamMechanic) inspType.push("MECHANIC");
                    // input.inspectorType = inspType;

                    API.graphql(graphqlOperation(createInspector, { input }))
                      .then(async res => {
                        const userObj = await Auth.signIn(username, password);
                        toast.success("User Created");
                        this.props.storeUser(userObj);
                        spinnerService.hide("mySpinner");
                      })
                      .catch(err => {
                      });
                  } catch (err) {
                  }
                })
            );
          });
        })
        .catch(err => {
          spinnerService.hide("mySpinner");
        });
    } catch (err) {
      spinnerService.hide("mySpinner");
    }
  };
  uploadImages = async () => {
    const { qualifications } = this.props.history.location.state.data;
    if (qualifications.length === 0) {
      return;
    }
    await Promise.all(
      qualifications.length !== 0 &&
      qualifications.map(async (item, index) => {
        if (item.file === null) {
          qualificationsArray.push({
            title: item.title,
            dateAchieved: currentDate,
            attachment: null
          });
        } else {
          try {
            let key = await Storage.put(
              new Date().getTime() + item.file.name,
              item.file
            );
            qualificationsArray.push({
              title: item.title,
              dateAchieved: currentDate,
              attachment: {
                bucket: "calbitwebappuploadbucket1254-dev",
                region: "us-east-2",
                key: key.key
              }
            });
          } catch (err) {
          }
        }
      })
    );
  };
  onInputChange = event => {
    this.setState({
      [event.target.id]: event.target.value
    });
    //document.getElementById(event.target.id).classList.remove("is-danger");
  };
  componentDidMount() {
    let { email } = JSON.parse(localStorage.getItem("inspectorInfo"));
    this.setState({ email });
  }
  resendCode = () => {
    let { email, password } = JSON.parse(localStorage.getItem("inspectorInfo"));
    Auth.resendSignUp({ username: email })
      .then(response => {
      })
      .catch(e => {
      });
  };

  render() {
    return (
      <div>
        <main ref="main">
          <section className="section section-shaped section-lg">
            <ToastContainer />
            <Container className=" pt-lg-sm pt-2">
              <Row className="justify-content-center">
                <Col lg="6">
                  <Card className="bg-secondary shadow border-0">
                    <CardHeader className="bg-white pb-2 pt-3">
                      <div className="pb-2">
                        <span style={{ fontSize: "30px" }}>
                          {" "}
                          Confirm Your Account{" "}
                        </span>
                      </div>
                    </CardHeader>

                    <CardBody className="bg-white  px-5 py-5">
                      <Form onSubmit={this.handleSubmit} role="form">
                        <FormGroup>
                          <InputGroup className=" input-group-alternative mb-3">
                            <InputGroupAddon addonType="prepend">
                              <InputGroupText></InputGroupText>
                            </InputGroupAddon>

                            <Input
                              value={this.state.email}
                              id="email"
                              placeholder="Email"
                              type="text"
                              readOnly
                              disabled
                            />
                          </InputGroup>
                        </FormGroup>
                        <FormGroup>
                          <InputGroup className="input-group-alternative mb-3">
                            <InputGroupAddon addonType="prepend">
                              <InputGroupText></InputGroupText>
                            </InputGroupAddon>
                            <Input
                              value={this.state.code}
                              id="code"
                              onChange={this.onInputChange}
                              placeholder="Confirmation Code"
                              type="text"
                            />
                          </InputGroup>
                        </FormGroup>
                        <Row>
                          <Col xs="auto">
                            <div
                              style={{
                                fontWeight: "bold",
                                fontSize: 12,
                                marginTop: 5,
                                marginBottom: 10
                              }}
                            >
                              Lost Your Code?
                              <span
                                onClick={() => this.resendCode()}
                                style={{
                                  color: "blue",
                                  textDecoration: "underline",
                                  cursor: "pointer"
                                }}
                              >
                                Please Resend
                              </span>
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col xs="auto">
                            <div>
                              <Button
                                className=""
                                type="submit"
                                color="primary"
                              >
                                Confirm Code
                              </Button>
                            </div>
                          </Col>
                        </Row>
                      </Form>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Container>
          </section>
        </main>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.config.user
  };
};
const mapDispatchToProps = dispatch => {
  return {
    storeUser: data => dispatch(actionTypes.storeUser(data))
  };
};
export default ConfirmSignUp2 = connect(
  mapStateToProps,
  mapDispatchToProps
)(ConfirmSignUp2);



// WEBPACK FOOTER //
// ./src/pages/confirmSignUp2.js